import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import {
  type IResponseKnowledgeBase,
  KnowledgeBase,
  KnowledgeBaseApi,
} from 'entities/KnowledgeBase'
import { AgentDocumentsStore } from './AgentDocumentsStore'

export class AgentKnowledgeBaseStore {
  private _isKnowledgeBaseInitLoading = false
  private _knowledgeBase: KnowledgeBase | null = null
  private _agentDocumentsStore: AgentDocumentsStore

  constructor(isInitAllDocuments?: boolean) {
    this._agentDocumentsStore = new AgentDocumentsStore(this, isInitAllDocuments)
    makeAutoObservable(this)
  }

  updateKnowledgeBase = (knowledgeBaseResponse: IResponseKnowledgeBase) => {
    this._knowledgeBase = new KnowledgeBase(knowledgeBaseResponse)
  }

  initKnowledgeBase = async () => {
    try {
      runInAction(() => {
        this._isKnowledgeBaseInitLoading = true
      })
      const { data } = await KnowledgeBaseApi.getKnowledgeBase()
      this.updateKnowledgeBase(data)
    } catch (error) {
      logger.error(error)
    } finally {
      runInAction(() => {
        this._isKnowledgeBaseInitLoading = false
      })
    }
  }

  get isKnowledgeBaseInitLoading() {
    return this._isKnowledgeBaseInitLoading
  }

  get knowledgeBase() {
    return this._knowledgeBase
  }

  get agentDocumentsStore() {
    return this._agentDocumentsStore
  }
  checkValidate = () => {
    let validate = true
    if (this.isKnowledgeBaseInitLoading) {
      validate = false
    }
    this.agentDocumentsStore.validateDocumentsList()
    if (this.agentDocumentsStore.documentsError) {
      validate = false
    }
    return validate
  }
}
